import React from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';

interface EmbedVideoPlayerProps {
  url: string;
  className?: string;
}

export const EmbedVideoPlayer = (props: EmbedVideoPlayerProps): JSX.Element => {
  return (
    <VideoContainer className={props.className}>
      <StyledReactPlayer
        src={props.url}
        width="100%"
        height="100%"
        controls={true}
        playsInline={true}
      />
    </VideoContainer>
  );
};

const VideoContainer = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 0;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
`;

const StyledReactPlayer = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;
